<div class="p-chips" dndDropzone (dndDrop)="onDrop($event)" [dndDisableDropIf]="!!dtoValue()">
  <ul class="p-inputtext p-chips-multiple-container">
    @if (dtoValue()) {
      <li class="p-chips-token">
        <span class="p-chips-token-label">{{ dtoValue() }}</span>

        <i class="clickable mynaui-x-circle" (click)="remove()"></i>
      </li>
    }

    @if (!disabled()) {
      <li class="p-chips-input-token">
        <input
          class="p-element"
          #inputField
          type="text"
          [formControl]="formControl"
          [formlyAttributes]="field"
          (input)="onInput($event)" />
      </li>
    }
  </ul>
</div>

@if (showError) {
  <div class="field-invalid-feedback">
    <formly-validation-message id="{{ id }}-formly-validation-error" [field]="field" role="alert" />
  </div>
}
